// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps, ButtonProps } from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { ProductAddToCartButtonStyles } from "@steiner/Overrides/Components/ProductAddToCartButton";
import { addToCartStatus, AddToCartStatusInfoInterface } from "@steiner/XDL/constants";
import Cart from "@steiner/XDL/Icons/Cart";
import { addToCartButtonStyles as addToCartButtonSharedStyles } from "@steiner/XDL/PreStyle/button";
import React, { useState } from "react";

interface OwnProps extends ButtonProps {
    currentStatus?: AddToCartStatusInfoInterface;
    displayAsIcon?: boolean;
    label?: string;
    extendedStyles?: ButtonPresentationProps;
}

export type Props = OwnProps;

export const addToCartButtonStyles: ProductAddToCartButtonStyles = {
    ...addToCartButtonSharedStyles,
    buttonIcon: {
        color: "common.ui6",
        size: 18,
    },
    spinner: {
        color: "common.ui6",
        size: 18,
    },
};

const icons = {
    default: Cart,
};

const AddToCartButton = ({
    currentStatus = addToCartStatus.default,
    displayAsIcon,
    label,
    extendedStyles,
    ...otherProps
}: Props) => {
    const [styles] = useState(() => mergeToNew(addToCartButtonStyles, extendedStyles));

    return (
        <Button {...styles} aria-label={translate("Add to Cart")} {...otherProps}>
            {currentStatus === addToCartStatus.loading && displayAsIcon ? (
                <LoadingSpinner {...styles.spinner} />
            ) : displayAsIcon ? (
                <Icon src={icons.default} {...styles.buttonIcon} />
            ) : (
                label
            )}
        </Button>
    );
};

export default AddToCartButton;
